import React from "react";
import "./style.css";

const NetworkErrorModal = ({ isModalOpen }) => {


  if (!isModalOpen) return null;

  return (
    <div className="network-modal-overlay">
      <div className="network-modal-content">
        <div>
          <p className="network-modal-title">
            Network Connection Lost
          </p>
          <p className="network-modal-subtitle">
            Please check your internet connection and try again.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NetworkErrorModal;
